import React from 'react';
import {ValueCell} from '../../../../../../components/initial-plan/ValueCell';
import {Data, HorizontalBar, Title, ValueContainer} from '../ProjectScopingTotals_styled';
import {Tile, TileRow} from './Tile_styled';
import {useIntl} from 'react-intl';
import {useProjectTotals} from '../ProjectScopingTotalsContext';

export const FixedPriceMiddleTile = (): JSX.Element => {
	const intl = useIntl();
	const {totalsData, settings} = useProjectTotals();
	return (
		<Tile>
			<TileRow>
				<Title singleLine>{intl.formatMessage({id: 'common.actual_hours'})}</Title>
				<Data small>
					<ValueContainer>
						<ValueCell
							noJustify
							cy={'actual_hours'}
							type={ValueCell.VALUE_TYPE.TIME}
							value={totalsData.actualHours}
							currencySymbol={settings.currencySymbol}
						/>
					</ValueContainer>
				</Data>
			</TileRow>
			<TileRow>
				<Title singleLine>{intl.formatMessage({id: 'common.projected_total_hours'})}</Title>
				<Data small>
					<ValueContainer>
						<ValueCell
							noJustify
							cy={'projected_total_hours'}
							type={ValueCell.VALUE_TYPE.TIME}
							value={totalsData.projectedTotalHours}
							currencySymbol={settings.currencySymbol}
						/>
					</ValueContainer>
				</Data>
			</TileRow>
			<HorizontalBar />

			<TileRow>
				<Title singleLine>{intl.formatMessage({id: 'common.actual_billable_hours'})}</Title>
				<Data small>
					<ValueContainer>
						<ValueCell
							noJustify
							cy={'actual_billable_hours'}
							type={ValueCell.VALUE_TYPE.TIME}
							value={totalsData.actualBillableHours}
							currencySymbol={settings.currencySymbol}
						/>
					</ValueContainer>
				</Data>
			</TileRow>
			<TileRow>
				<Title singleLine>{intl.formatMessage({id: 'common.actual_non_billable_hours'})}</Title>
				<Data small>
					<ValueContainer>
						<ValueCell
							noJustify
							cy={'actual_non_billable_hours'}
							type={ValueCell.VALUE_TYPE.TIME}
							value={totalsData.actualNonBillableHours}
						/>
					</ValueContainer>
				</Data>
			</TileRow>
		</Tile>
	);
};
